var render = function (_h,_vm) {var _c=_vm._c;return _c('a',{attrs:{"href":_vm.props.url,"target":_vm.props.target}},[_vm._t("default",[_vm._v(_vm._s(_vm.props.text))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }